import { useEffect } from "react";
import ReactGA from "react-ga4";

import {
    ONE_TRUST_COOKIE_NAME,
    ONE_TRUST_TRACKING_ENABLED,
    ONE_TRUST_TRACKING_DISABLED,
    REACT_APP_TRACKER_ID,
    REACT_APP_ONETRUST_SCRIPT_SRC,
    REACT_APP_ONETRUST_DATA_DOCUMENT_LANGUAGE,
    REACT_APP_ONETRUST_SCRIPT_CHARSET, REACT_APP_ONETRUST_ID
} from "../../utils/GAConstants";

import Cookies from 'js-cookie';

const OneTrustComponent = () => {
    const cookies = Cookies.get();
    const removeCookie = Cookies.remove;

    useEffect(() => {
        const head = document.querySelector("head");
        const script = document.createElement("script");

        script.setAttribute("src", REACT_APP_ONETRUST_SCRIPT_SRC);
        script.setAttribute("data-document-language", REACT_APP_ONETRUST_DATA_DOCUMENT_LANGUAGE);
        script.setAttribute("charSet", REACT_APP_ONETRUST_SCRIPT_CHARSET);
        script.setAttribute("data-domain-script", REACT_APP_ONETRUST_ID);

        head.appendChild(script);
        return () => {
            head.removeChild(script);
        };
    }, []);

    useEffect(() => {
        const cookieValue = cookies[ONE_TRUST_COOKIE_NAME];
        if (!cookieValue ||isEmpty(cookieValue)){
            return;
        }

        const getTrackerId = () => {
            const trackerId = REACT_APP_TRACKER_ID || "DEFAULT_TRACKER_ID";
            if (!trackerId || trackerId.trim() === "") {
                console.error("Tracker ID is not set or invalid.");
                return "DEFAULT_TRACKER_ID";
            }
            return trackerId;
        };

        const googleTrackedCookieName = "_ga_" + getTrackerId();

        // Remove GA tracking
        if (cookieValue && cookieValue.indexOf(ONE_TRUST_TRACKING_DISABLED) > 0 && cookies[googleTrackedCookieName]) {
            const domain = extractDomain(window.location.hostname);
            const attributes = { path: "/", domain: domain };

            removeCookie(googleTrackedCookieName, attributes);
            removeCookie("_ga", attributes);
            removeCookie("_gat", attributes);
            removeCookie("_gid", attributes);
            window.location.reload();
        }

        // Add GA tracking
        else if (cookieValue && cookieValue.indexOf(ONE_TRUST_TRACKING_ENABLED) > 0) {
            ReactGA.initialize("G-" + getTrackerId(), {
                gaOptions: {},
            });
        }
    }, [cookies, removeCookie]);

    const extractDomain = (hostname) => {
        let domain = "";

        if (hostname.includes("localhost")) {
            domain = "localhost";
        } else {
            const parts = hostname.split(".");

            if (parts.length > 1) {
                domain = "." + parts[parts.length - 2] + "." + parts[parts.length - 1];
            }
        }

        return domain;
    };

    function isNotEmpty(str) {
        return str && str.toString().trim().length > 0;
    }

    function isEmpty(str) {
        return !isNotEmpty(str);
    }

}

export default OneTrustComponent;
